import { StandardDialog, } from '@roc/ui';
import { observer } from 'mobx-react';
import { makeStyles } from '@material-ui/core/styles';
import { PayableAttestationDashboard } from '@roc/feature-special-servicing';
import { Document } from '@roc/feature-types';
import { CustomTaskDialog } from '@roc/feature-general-tasks';

interface IAttestationDialogProps {
  loanId: number;
  open: boolean;
  onClose: () => void;
  type: string;
  document: Document;
}

const useStyles = makeStyles(theme => ({
  attestationModalContent: {
    padding: 0,
    margin: 0,
  }
}));

export const AttestationDialog = observer(({ loanId, type, open, onClose, document }: IAttestationDialogProps) => {
  const taskId = document?.taskId;
  const classes = useStyles();

  return (


    <>
      {taskId ? (
        <CustomTaskDialog
          title='Attestation'
          classes={{
            root: classes.attestationModalContent,
            paper: classes.attestationModalContent
          }}
          open={open}
          handleClose={onClose}
          dialogContentclasses={{ root: classes.attestationModalContent }}
          dialogContent={(
            <PayableAttestationDashboard
              loanId={loanId}
              type={type}
              handleClose={() => {
                onClose();
              }}
            />
          )}
          taskId={taskId}
        />

      ) : (
        <StandardDialog
          maxWidth="md"
          hideBackdrop={true}
          classes={{
            root: classes.attestationModalContent,
            paper: classes.attestationModalContent
          }}
          removeContentBox
          open={open}
          handleClose={onClose}
          dialogContentclasses={{ root: classes.attestationModalContent }}
          dialogContent={(
            <PayableAttestationDashboard
              loanId={loanId}
              type={type}
              handleClose={() => {
                onClose();
              }}
            />
          )}
        />


      )}
    </>

  );
});